import React from 'react';

import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';

import {
  ActualOperation,
  DropdownObjectType,
  OperationAttainment
} from '../types/interfaces';

interface TagsComponentProps {
  passedClassName?: string;
  actualOperations: ActualOperation[];
  tagsItems: DropdownObjectType[];
  onDelete?: (taskId: string | number) => void;
  plannedOperationsAttainments?: OperationAttainment[];
  withTooltip?: boolean;
  withoutDelete?: boolean;
}

export const TagsComponentWithUnderline: React.FC<TagsComponentProps> = ({
  passedClassName,
  actualOperations,
  tagsItems,
  onDelete,
  plannedOperationsAttainments = [],
  withTooltip = false,
  withoutDelete
}) => {
  const actualJobKeys = new Set(
    Array.isArray(actualOperations)
      ? actualOperations.map((job) => job.operation.key)
      : []
  );

  const getTagStyle = (tagKey: string | number) => {
    const isPlanned = tagsItems.some((item) => item.key === tagKey);
    const isActual = actualJobKeys.has(tagKey);

    if (isPlanned && isActual) {
      return { backgroundColor: 'rgb(34, 197, 94, 0.18)' };
    } else if (isPlanned && !isActual) {
      return { backgroundColor: 'rgb(143, 143, 143,  0.18)' };
    }
    return {};
  };

  const getAttainmentsForOperation = (operationKey: string | number) => {
    const attainment = plannedOperationsAttainments.find(
      item => item.operationType.id.toString() === operationKey.toString()
    );
    return attainment?.attainments || [];
  };

  const getTooltipContent = (operationKey: string | number) => {
    const attainments = getAttainmentsForOperation(operationKey);
    if (attainments.length === 0) {
      return 'Требуемые навыки отсутствуют';
    }
    return ('Требуемые навыки:\n' + attainments.map(attainment => attainment.label).join(',\n'));
  };

  const handleDeleteAll = (taskId: string | number) => {
    if (taskId !== undefined) {
      onDelete?.(taskId);
    }
  };

  return (
    <div
      className={`tag-component flex pt-2 flex-wrap ${
        passedClassName ? passedClassName : 'gap-3'
      }`}
    >
      {tagsItems.map((tagItem, index) => {
        const attainments = getAttainmentsForOperation(tagItem.key);
        const hasAttainments = attainments.length > 0;
        const tooltipId = `tooltip-${tagItem.key}-${index}`;
        
        return (
          <React.Fragment key={tagItem.key}>
            {withTooltip && hasAttainments && (
              <Tooltip 
                id={tooltipId}
                target={`#${tooltipId}`}
                content={getTooltipContent(tagItem.key)}
                style={{ whiteSpace: 'pre-line' }}
              />
            )}
            <div
              id={hasAttainments ? tooltipId : undefined}
              data-pr-tooltip={hasAttainments ? getTooltipContent(tagItem.key) : undefined}
              className="flex border-round-2xl pl-2"
              style={{
                background: (tagItem as any)?.isDeleted ? 'rgb(245, 225, 226)' : 'rgb(225, 234, 245)',
                ...((tagItem as any)?.isDeleted ? {} : getTagStyle(tagItem.key)),
                cursor: hasAttainments ? 'help' : 'default'
              }}
            >
              <div className="task-status flex flex-row gap-2 align-items-center">
                {(tagItem as any)?.isDeleted && (
                  <i
                    className="pi pi-exclamation-circle"
                    style={{ color: 'rgb(255, 168, 0)', fontSize: '0.85rem' }}
                    title="Удалено в справочнике"
                  />
                )}
                {withTooltip && hasAttainments && !((tagItem as any)?.isDeleted) && <i className="pi pi-question-circle"></i>}
                <div className="flex m-0 font-medium">{tagItem.label}</div>
                {!withoutDelete ? (
                  <Button
                    icon="pi pi-times"
                    className="p-0"
                    style={{ color: '#475569', width: '2rem' }}
                    onClick={() => handleDeleteAll(tagItem.key)}
                    text
                  />
                ) : (
                  <div></div>
                )}
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};